/**
 * Create the store with dynamic reducers
 */

import { createStore, applyMiddleware, compose } from 'redux';
import { fromJS } from 'immutable';
import createSagaMiddleware from 'redux-saga';
import createReducer from './reducers';

const sagaMiddleware = createSagaMiddleware();

// Simple action logger middleware for debugging
const actionLogger = store => next => action => {
  if (action && action.type) {
    if (action.type.includes('SET_VACATION')) {
      console.log('[ACTION DISPATCHED]', action);
    }
    if (action.type.includes('FETCH_ME')) {
      console.log('[AUTH ACTION]', action.type);
    }
    if (action.type.includes('LOGOUT')) {
      console.log('[AUTH ACTION] LOGOUT triggered');
    }
  }
  return next(action);
};

export default function configureStore(initialState = {}) {
  // Create the store with sagaMiddleware
  // sagaMiddleware: Makes redux-sagas work
  const middlewares = [actionLogger, sagaMiddleware];

  const enhancers = [applyMiddleware(...middlewares)];

  // If Redux DevTools Extension is installed use it, otherwise use Redux compose

  const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          // TODO: Try to remove when `react-router-redux` is out of beta, LOCATION_CHANGE should not be fired more than once after hot reloading
          // Prevent recomputing reducers for `replaceReducer`
          shouldHotReload: false,
        })
      : compose;


  const store = createStore(
    createReducer(),
    fromJS(initialState),
    composeEnhancers(...enhancers),
  );

  // Extensions
  store.runSaga = sagaMiddleware.run;
  store.injectedReducers = {}; // Reducer registry
  store.injectedSagas = {}; // Saga registry

  // Make reducers hot reloadable, see http://mxs.is/googmo
  /* istanbul ignore next */
  if (module.hot) {
    module.hot.accept('./reducers', () => {
      store.replaceReducer(createReducer(store.injectedReducers));
    });
  }

  return store;
}
